module.exports = __webpack_public_path__ + "static/media/retainer-small.3c2f7170.jpg";